/**
 * Admin Portal Localized Strings
 *
 * These strings are passed to I18nProvider from @common-ui-library/shared
 * and can be accessed via the t() function from useI18n().
 *
 * Translation lookup order:
 * 1. This namespace (adminPortal)
 * 2. commonUI namespace (fallback to shared library strings)
 */

export const adminPortalStrings = {
  en: {
    labels: {
      name: 'Name',
      email: 'Email',
      phoneNumber: 'Phone Number',
      profession: 'Profession',
      site: 'Site',
      siteName: 'Site Name',
      organization: 'Organization',
      timezone: 'Timezone',
      supervisor: 'Supervisor',
      program: 'Program',
      excludeFromMetrics: 'Exclude from Metrics',
      adminInOrg: 'Admin in Organization',
      adminAccessDescription: 'Grants full administrative access to manage users, sites, and settings',
      showInactiveUsers: 'Show inactive users',
      filters: 'Filters',
      none: 'None',
      active: 'Active:',
      never: 'Never',
      error: 'Error',
      details: 'Details',
    },
    placeholders: {
      selectList: 'Select from list',
    },
    buttons: {
      create: 'Create',
      clear: 'Clear',
      apply: 'Apply',
      updateUserInfo: 'Update User Info',
      deactivateUser: 'Deactivate User',
      reactivateUser: 'Reactivate User',
      updateSite: 'Update Site',
    },
    actions: {
      retry: 'Retry',
      goToHome: 'Go to Home',
      refreshPage: 'Refresh Page',
      tryAgain: 'Try Again',
      loginAgain: 'Login Again',
      logout: 'Logout',
    },
    navigation: {
      sites: 'Sites',
      users: 'Users',
    },
    titles: {
      addNewProvider: 'Add New User',
      addNewSite: 'Add New Site',
      providerDetails: 'User Details',
      siteDetails: 'Site Details',
    },
    errors: {
      fetchFailed: 'Failed to load data. Please try again.',
      duplicateEmail: 'A user with this email already exists.',
      reactivateFailed: 'Failed to reactivate. Please try again.',
      unauthorized: 'Unauthorized Access',
      unauthorizedMessage: "You don't have permission to access this page. Please contact your administrator if you believe this is a mistake.",
      sessionExpired: 'Session Expired',
      sessionExpiredMessage: 'Your session has expired. Please log in again to continue.',
      serverErrorMessage: 'We encountered an unexpected error. Please try again.',
      pageNotFound: 'Page Not Found',
      pageNotFoundMessage: "The page you're looking for doesn't exist or has been moved.",
      somethingWentWrong: 'Something Went Wrong',
      unexpectedError: 'An unexpected error occurred. Please try refreshing the page. If the problem persists, contact your administrator.',
      authenticationFailed: 'Authentication Failed',
      authErrorMessage: 'We encountered an issue while trying to sign you in. This may be due to your account configuration.',
      contactSupport: 'If this problem persists, please contact your administrator or support team.',
    },
    snackbar: {
      userCreated: 'User created successfully',
      userUpdated: 'User updated successfully',
      userDeactivated: 'User deactivated successfully',
      userReactivated: 'User reactivated successfully',
    },
  },
} as const;
